"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatToken = exports.composeToken = void 0;
const BEARER = 'Bearer ';

/**
 * Composes a token string with a "Bearer" prefix if it doesn't already have one.
 * @param {string} token - The `token` parameter is a string representing an authentication token.
 */
const composeToken = token => token.includes(BEARER) ? token : `${BEARER}${token}`;

/**
 * Formats a token string if it exists, otherwise it returns undefined.
 * @param {string | null | undefined} token - The `token` parameter is a string that can also be `null`
 * or `undefined`.
 */
exports.composeToken = composeToken;
const formatToken = token => token ? composeToken(token) : undefined;
exports.formatToken = formatToken;
//# sourceMappingURL=prepareToken.js.map